import(/* webpackMode: "eager" */ "/app/apps/platform-web/app/v2/v2.css");
;
import(/* webpackMode: "eager", webpackExports: ["TalentPopupProvider"] */ "/app/apps/platform-web/components/talent/feedback/TalentPopupProvider.tsx");
